const fr = {
  // Nav
  nav: {
    home: 'Accueil',
    menu: 'Carte',
    order: 'Commander',
    gallery: 'Galerie',
    reviews: 'Avis',
    reservation: 'Reservation',
    reserve: 'Reserver',
  },

  // Home page
  home: {
    sectionCuisine: 'Notre cuisine',
    sectionAtmosphere: 'Atmosphere',
    sectionFormules: 'Nos formules',
    sectionActus: 'Actualites',
    sectionSocial: 'Suivez-nous',
    sectionExceptions: 'Horaires exceptionnels',
    formulesSubtitle: 'Des prix qui font plaisir',
    actusSubtitle: 'Quoi de neuf ?',
    seeGallery: 'Voir la galerie photos',
    seeFullMenu: 'Decouvrir toute la carte',
    googleRating: '4,1/5 sur Google',
    googleRatingValue: '4,1',
    googleReviewsCount: '150 avis',
    formulesFrom: 'Formules dès 15 €',
    closed: 'Ferme',
    burgersCount: 'burgers au choix',
    callUs: 'Nous appeler',
    directions: 'Itineraire',

    // Fallback hero/about/atmosphere
    defaultHeroTitle: 'Votre restaurant de quartier a Bordeaux',
    defaultHeroSubtitle: 'Cuisine simple et genereuse, terrasse ombragee, ambiance conviviale.',
    defaultAboutTitle: 'Simple, frais et genereux',
    defaultAboutText: 'Chez Cote Terrasse, nous preparons une cuisine sincere a base de produits frais et de saison.',
    defaultAtmosphereTitle: 'Une terrasse cote jardin',
    defaultAtmosphereText: 'Profitez de notre salle cote jardin, un veritable havre de paix en plein Bordeaux.',
    defaultCtaTitle: 'Envie de venir ?',
    defaultCtaText: 'Reservez votre table en quelques clics ou passez nous voir directement.',
    defaultBtnReserve: 'Reserver une table',
    defaultBtnMenu: 'Voir la carte',
    defaultBtnCall: 'Nous appeler',
    defaultBtnDirections: 'Itineraire',
  },

  // Reservation
  reservation: {
    sectionLabel: 'Reservation & Contact',
    titleOnline: 'Reservez votre table',
    titlePhone: 'Reservez par telephone',
    phoneOnly: 'Reservation par telephone uniquement',
    phoneDesc: 'Pour reserver une table, appelez-nous directement. Notre equipe se fera un plaisir de vous accueillir.',
    callNow: 'Appeler maintenant',
    noPhone: 'Numero de telephone non renseigne. Contactez l\'administrateur.',
    formTitle: 'Demande de reservation',
    name: 'Nom',
    phone: 'Telephone',
    email: 'Email',
    date: 'Date',
    time: 'Heure',
    guests: 'Personnes',
    guestSingular: 'personne',
    guestPlural: 'personnes',
    message: 'Message (optionnel)',
    messagePlaceholder: 'Allergies, demandes speciales...',
    choose: 'Choisir',
    namePlaceholder: 'Votre nom',
    phonePlaceholder: '06 ...',
    emailPlaceholder: 'votre@email.com',
    submit: 'Envoyer la demande',
    sending: 'Envoi en cours...',
    success: 'Demande de reservation envoyee ! Nous vous contacterons bientot.',
    errorDate: 'Veuillez selectionner une date',
    errorTime: 'Veuillez selectionner une heure',
    errorGeneric: 'Erreur lors de l\'envoi. Veuillez reessayer.',
    infoTitle: 'Informations pratiques',
    openingHours: 'Horaires d\'ouverture',
    closed: 'Ferme',
  },

  // Gallery
  gallery: {
    sectionLabel: 'Galerie',
    title: 'En images',
    description: 'Decouvrez notre terrasse, notre salle cote jardin et nos plats en photos.',
    all: 'Toutes',
    plats: 'Plats',
    terrasse: 'Terrasse',
    salle: 'Salle',
    ambiance: 'Ambiance',
    empty: 'Aucune photo dans cette categorie.',
    lightboxTitle: 'Photo de la galerie',
  },

  // Menu
  menu: {
    sectionLabel: 'Notre carte',
    title: 'La Carte',
    description: 'Decouvrez nos burgers maison, tapas a partager, et nos formules avantageuses. Cuisine preparee avec des produits frais et de saison.',
    formules: 'Formules',
    supplements: 'Supplements:',
    from: 'des',
    sides: 'Accompagnements',
    sidesIncluded: 'Compris dans le prix du burger:',
    sidesIncludedText: 'Frites fraiches ou Salade de saison.',
    sidesSupplements: 'Supplements:',
    sidesSupplementsText: 'Frites de Patate douce +3EUR | Bacon +3EUR | Cheddar +2EUR',
    sidesNote: 'Steack ANGUS 100% Pur Boeuf Origine France 150gr — Frites Fraiches cuites a la Belge au Blanc de Boeuf — Magret de Canard Sud-Ouest de France',
  },

  // Reviews
  reviews: {
    sectionLabel: 'Avis clients',
    title: 'Ce qu\'ils en pensent',
    description: 'Majorite d\'avis 4 et 5 etoiles. Nos clients apprecient la qualite de notre cuisine, nos prix raisonnables et notre ambiance conviviale.',
    outOf: 'Sur plus de 200 avis',
  },

  // Legal
  legal: {
    title: 'Mentions legales',
    editor: 'Editeur du site',
    hosting: 'Hebergement',
    ip: 'Propriete intellectuelle',
    ipText: 'L\'ensemble du contenu de ce site (textes, images, logos, photos) est la propriete exclusive de Cote Terrasse, sauf mention contraire. Toute reproduction, meme partielle, est interdite sans autorisation prealable.',
    data: 'Donnees personnelles',
    dataText: 'Les informations collectees via le formulaire de reservation (nom, email, telephone) sont utilisees uniquement pour le traitement de votre demande de reservation. Conformement au RGPD, vous disposez d\'un droit d\'acces, de rectification, de limitation et de suppression de vos donnees personnelles.',
    dataTextPhone: 'Nous ne collectons aucune donnee personnelle directement sur ce site pour les reservations, celles-ci s\'effectuant exclusivement par telephone. Conformement au RGPD, vous disposez d\'un droit d\'acces, de rectification, de limitation et de suppression des informations vous concernant.',
    cookies: 'Cookies',
    cookiesText: 'Ce site utilise des cookies techniques necessaires a son bon fonctionnement. Aucun cookie publicitaire ou de suivi n\'est utilise.',
    privacy: 'Politique de confidentialite',
    privacyText: 'Nous nous engageons a proteger votre vie privee. Les donnees personnelles que vous nous communiquez ne sont jamais transmises a des tiers. Elles sont conservees pendant une duree maximale de 12 mois.',
    responsibility: 'Responsabilite',
    responsibilityText: 'Cote Terrasse s\'efforce de fournir des informations aussi precises que possible. Les prix et horaires affiches sont susceptibles de modifications sans preavis.',
    publishedBy: 'Directeur de la publication',
    phone: 'Telephone',
    mediation: 'Mediation de la consommation',
    alcohol: 'Licence d\'alcool',
    meatOrigin: 'Origine des viandes',
  },

  // Cookies banner
  cookies: {
    bannerText: 'Cote Terrasse utilise des cookies pour assurer le bon fonctionnement de son site. Vous pouvez choisir d\'accepter ou de personnaliser l\'utilisation des cookies de mesure d\'audience.',
    accept: 'Tout accepter',
    decline: 'Refuser',
    customize: 'Personnaliser',
    save: 'Enregistrer mes choix',
    essentialOnly: 'Uniquement les cookies essentiels',
    title: 'Parametres des cookies',
    essentialTitle: 'Cookies techniques (Obligatoires)',
    essentialDesc: 'Ces cookies sont indispensables au bon fonctionnement du site (session admin, gestion du panier). Ils ne peuvent pas etre desactives.',
    analyticsTitle: 'Cookies analytiques (Optionnels)',
    analyticsDesc: 'Ces cookies nous permettent de mesurer la frequentation du site et d\'ameliorer votre experience de navigation (ex: Google Analytics).',
  },

  // CGV
  cgv: {
    title: 'Conditions Generales de Vente (CGV)',
    intro: 'Les presentes Conditions Generales de Vente regissent les commandes passees dans le cadre du service de Click & Collect propose par le restaurant Cote Terrasse.',
    article1Title: '1. Objet',
    article1Text: 'Les CGV s\'appliquent a toute commande de plats effectuee par le Client sur le site et a retirer au restaurant Cote Terrasse.',
    article2Title: '2. Commande et Obligation de paiement',
    article2Text: 'Toute validation de commande sur le site implique une obligation de paiement de la part du Client. Le paiement s\'effectue en ligne ou lors du retrait selon les options proposees.',
    article3Title: '3. Droit de retractation (Exclusion)',
    article3Text: 'Conformement a l\'article L. 221-28 12° du Code de la consommation, les contrats de prestations de services de restauration devant etre fournis a une date ou a une periode determinee ne beneficient pas du droit de retractation. Les produits etant perissables et prepares a la demande, aucune commande validee ne peut etre annulee ou remboursee.',
    article4Title: '4. Retrait des commandes',
    article4Text: 'Le Client s\'engage a retirer sa commande au jour et au creneau horaire choisis lors de la validation. En raison du caractere perissable des produits, aucune commande non reclamee ne pourra etre remboursee ou conservee au-dela du jour de retrait.',
    article5Title: '5. Mediation de la consommation',
    article5Text: 'En cas de litige non resolu, le Client peut saisir le mediateur de la consommation agree. Les coordonnees de notre mediateur designe sont consultables sur la page Mentions Legales du site.',
  },

  // Allergènes
  allergens: {
    title: 'Allergenes Reglementaires',
    subtitle: 'Conformement au Reglement (UE) n° 1169/2011, voici la liste des 14 allergenes majeurs pouvant etre presents dans nos preparations :',
    notice: 'Notre equipe reste a votre entiere disposition pour tout detail concernant la composition precise de nos plats.',
    names: {
      gluten: 'Gluten',
      crustaceans: 'Crustaces',
      eggs: 'Oeufs',
      fish: 'Poisson',
      peanuts: 'Arachides',
      soybeans: 'Soja',
      milk: 'Lait',
      nuts: 'Fruits a coque',
      celery: 'Celeri',
      mustard: 'Moutarde',
      sesame: 'Graines de sesame',
      sulphites: 'Sulfites',
      lupin: 'Lupin',
      molluscs: 'Mollusques',
    },
    list: {
      gluten: 'Cereales contenant du gluten (ble, seigle, orge, avoine...)',
      crustaceans: 'Crustaces et produits a base de crustaces',
      eggs: 'Oeufs et produits a base d\'oeufs',
      fish: 'Poissons et produits a base de poissons',
      peanuts: 'Arachides et produits a base d\'arachides',
      soybeans: 'Soja et produits a base de soja',
      milk: 'Lait et produits a base de lait (y compris le lactose)',
      nuts: 'Fruits a coque (amandes, noisettes, noix, pistaches...)',
      celery: 'Celeri et produits a base de celeri',
      mustard: 'Moutarde et produits a base de moutarde',
      sesame: 'Graines de sesame et produits a base de graines de sesame',
      sulphites: 'Anhydride sulfureux et sulfites (en concentration de plus de 10 mg/kg ou 10 mg/l)',
      lupin: 'Lupin et produits a base de lupin',
      molluscs: 'Mollusques et produits a base de mollusques',
    }
  },

  // Footer
  footer: {
    description: 'Restaurant convivial a Bordeaux. Cuisine de saison, burgers maison et une terrasse agreable cote jardin.',
    navigation: 'Navigation',
    contact: 'Contact',
    ourMenu: 'Notre Carte',
    customerReviews: 'Avis Clients',
    legalNotice: 'Mentions legales',
    legalAndPrivacy: 'Mentions legales & Politique de confidentialite',
    admin: 'Administration',
    copyright: 'Tous droits reserves.',
    defaultAccessTram: 'Accès : Tram A (arrêt à proximité)',
    defaultAccessBus: 'Bus 9 (arrêt à proximité)',
    allergenNotice: 'Prix nets exprimes en Euros TTC. Conformement au decret n° 2015-447, les informations sur les allergenes presents dans nos plats sont disponibles sur simple demande ou consultables sur la page Allergenes.',
  },

  // Maintenance
  maintenance: {
    comingSoon: 'Nous revenons bientot',
    defaultMessage: 'Notre site est actuellement en cours de mise a jour. Merci de votre patience.',
    openingHours: 'Horaires d\'ouverture',
    closed: 'Ferme',
    copyright: 'Tous droits reserves.',
  },

  // Common
  common: {
    closed: 'Ferme',
    loading: 'Chargement...',
  },
};

export default fr;
